export const rectFromPoints = (origin, current) => ({
    x: Math.min(origin.x, current.x),
    y: Math.min(origin.y, current.y),
    width: Math.abs(current.x - origin.x),
    height: Math.abs(current.y - origin.y),
});
const MIN_DRAG_AREA = 8 * 8;
export const isRectNonTrivial = (rect) => rect.width * rect.height >= MIN_DRAG_AREA;
export const elementsInRect = (rect, ignore, root = document) => {
    const all = root.querySelectorAll("*");
    const out = [];
    for (const el of Array.from(all)) {
        if (ignore.some((ig) => ig === el || ig.contains(el)))
            continue;
        const r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0)
            continue;
        const overlap = !(r.right < rect.x ||
            r.left > rect.x + rect.width ||
            r.bottom < rect.y ||
            r.top > rect.y + rect.height);
        if (overlap)
            out.push(el);
    }
    return out;
};
//# sourceMappingURL=dragRect.js.map